/**
 * Gestion du formulaire de reservervation de stage
 * -ne gère que la couche tagmanager pour le moment
 */
 import './form';


 (function (w) {
     // Définit l'objet Completude
     w.Completude = Object.assign({}, w.Completude);
     w.Completude.formStage  = { 
        
        parametres : {},

        /**
        * Initalisation du module
        */
        init: function () {
            this.parametres = w.Completude.GetQueryParameters();
            if (typeof(this.parametres.stageVisio)!=='undefined' && this.parametres.stageVisio==="1" ) {
                this.stageVisio = true;
            }

            if (this.stageVisio) {
                w.Completude.TagManagerTunnel('tarifStage/step-2');                
            } else {
                w.Completude.TagManagerTunnel('tarifStage/step-1.1');                
            }

        }

     }
 })(window);


 jQuery(function () {
    if (jQuery("#section-reserver-stage").length > 0) {
        window.Completude.formStage.init();
    }
    if (jQuery("#section-paiement-stage-back").length > 0) {
        this.parametres = window.Completude.GetQueryParameters();
        if (typeof(this.parametres.act)!=='undefined' && this.parametres.act==="Succes" ) {
            window.Completude.TagManagerTunnel('paiementStage/step-3-success');   
        }             
        else if (typeof(this.parametres.act)!=='undefined' && this.parametres.act==="Echec" ) {
            window.Completude.TagManagerTunnel('paiementStage/step-3-fail');
        }
    }
});